export interface ContractMessageConfig {
  text: string;
  type: "success" | "info" | "warning" | "error";
}

export const contractMessages: Record<string, ContractMessageConfig> = {
  draftForOperator: {
    text: "Проверьте параметры договора",
    type: "info",
  },
  draftForCustomer: {
    text: "Ожидайте проверки и одобрения оператором Платформы",
    type: "info",
  },
  companyTypeMismatch: {
    text: "Тип компании в УНК не соответствует",
    type: "warning",
  },
  directionMismatch: {
    text: "Тип договора не соответствует УНК",
    type: "warning",
  },
  unkRegisteredInOtherBank: {
    text: "УНК зарегистрирован в другом банке, код регистрации банка {bankRegNum}",
    type: "warning",
  },
};

export type ContractMessageKey = keyof typeof contractMessages;
